import {
    Divider,
    LinearProgress,
    linearProgressClasses, Stack
} from "@mui/material";
import styled from "@emotion/styled";
import {CloudOutlined} from "@mui/icons-material";

import styles from "./storageStatus.module.css";
import {useEffect, useState} from "react";
import DriveService from "../../services/DriveService";
import useCalculator from "../../hooks/useCalculator";

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
    height: 5,
    borderRadius: 5,
    [`&.${linearProgressClasses.colorPrimary}`]: {
        backgroundColor: theme.palette.mode === 'light' ? '#cce4ff' : '#c3e2ff',
    },
    [`& .${linearProgressClasses.bar}`]: {
        borderRadius: 5,
        backgroundColor: theme.palette.mode === 'light' ? '#1a90ff' : '#308fe8',
    },
}));
export default function StorageStatus() {

    const {byteConversion} = useCalculator();
    const [data, setData] = useState([]);
    useEffect(() => {
        init();
    }, []);
    const init = async () => {
        const usage = await DriveService.getUser();
        try {
            setData({ progress: getProgress(usage[0]), usageStatus : usageStatusString(usage[0])})
        }catch (e) {
            console.error(e);
        }
    }
    const getProgress = (usage) => {
        return (usage['UsedStorage']/usage['Storage']) * 100;
    }
    const usageStatusString = (usage) => {
        return byteConversion(usage['UsedStorage']) + " used from " + byteConversion(usage['Storage'])

    }

    return <div className={styles.root}>
        <Stack direction="row" spacing={2}><CloudOutlined/> <p>Storage</p></Stack>
        <div className={styles.progress}>
            <BorderLinearProgress variant="determinate" value={data.progress} />
            <p className={styles.usageText}>{data.usageStatus}</p>
        </div>
        <Divider/>
    </div>
}